import React from 'react';
import C from 'classnames';
const sizeMapper = {
    lg: 'btn-lg',
    sm: 'btn-sm'
};
const variantMapper = (outline) => {
    if (outline) {
        return {
            primary: 'btn-outline-primary',
            secondary: 'btn-outline-secondary',
            success: 'btn-outline-success',
            info: 'btn-outline-info',
            warning: 'btn-outline-warning',
            danger: 'btn-outline-danger',
            light: 'btn-outline-light',
            dark: 'btn-outline-dark',
            white: 'btn-outline-white'
        };
    }
    else {
        return {
            primary: 'btn-primary',
            secondary: 'btn-secondary',
            success: 'btn-success',
            info: 'btn-info',
            warning: 'btn-warning',
            danger: 'btn-danger',
            light: 'btn-light',
            dark: 'btn-dark',
            white: 'btn-white'
        };
    }
};
export const RadioButton = (props) => {
    return (React.createElement("label", { className: C('btn', props.className, props.variant && variantMapper(props.outline)[props.variant], props.size && sizeMapper[props.size], props.rounded && 'btn-rounded-circle', props.active && 'active', props.disabled && 'disabled', props.block && 'btn-block', props.checked && 'active') },
        React.createElement("input", { type: "radio", name: props.name, checked: props.checked, onClick: props.onClick }),
        props.children));
};
//# sourceMappingURL=RadioButton.js.map